import { ApiObject } from '@hbf/analytics';

import { ProductID } from '@kamernet/core/ApiClient/Kamernet';

export function getPurchaseEventPayload({
  paymentIntentID,
  productID,
  price,
}: {
  paymentIntentID: string;
  productID: ProductID;
  price: number;
}): ApiObject {
  const priceWithoutVAT = Math.floor(price ? price / (1 + 0.21) : 1);

  return {
    content_id: productID,
    order_id: paymentIntentID,
    currency: 'EUR', // all
    revenue: priceWithoutVAT,
    value: priceWithoutVAT,
  };
}
